import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { SrxApi } from "../../api/SrxApi";

const useExportFile = () => {

  const { mutate: exportFile, isLoading } = useMutation(
    async ({ url, fileName, params }) => {
      const response = await SrxApi.get(url, {
        responseType: "blob",
        params,
      });

      return { blob: response.data, headers: response.headers, fileName };
    },
    {
      onSuccess: ({ blob, headers, fileName }) => {
        if (!blob) {
          toast.error("No file received");
          return;
        }
        const contentType = headers["content-type"];

        const fileBlob = new Blob([blob], { type: contentType });

        const fileUrl = window.URL.createObjectURL(fileBlob);

        const link = document.createElement("a");
        link.href = fileUrl;
        link.download =
          fileName ||
          (contentType.includes("excel")
            ? "export.xlsx"
            : "export.pdf");

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(fileUrl);
        toast.success("File Exported successfully!");
      },

      onError: (error) => {
        const errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Failed to export file";

        toast.error(errorMessage);
      },
    }
  );

  return {
    exportFile,
    isExportFileLoading: isLoading,
  };
};

export default useExportFile;
